import { render, staticRenderFns } from "./TitleColor.vue?vue&type=template&id=879d4f46&"
import script from "./TitleColor.vue?vue&type=script&lang=js&"
export * from "./TitleColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports